export const integralActivityTypes = {
  double: {
    value: 0,
    name: '积分翻倍',
    type: '',
  },
  accumulate: {
    value: 1,
    name: '累计签到',
    type: 'success',
  },
};

export function findIntegralActivityType(integralActivityTypeValue) {
  for (const key in integralActivityTypes) {
    if (integralActivityTypeValue === integralActivityTypes[key].value) return [integralActivityTypes[key]];
  }
}
